<!-- Live Auction Vehicles -->
<div class="card">
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <div class="d-flex align-items-center my-1">
        <i class="ki-duotone ki-car fs-2 me-3">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <h3 class="fw-bold m-0">Live Auction Vehicles</h3>
      </div>
    </div>
    <div class="card-toolbar">
      <div class="d-flex justify-content-end" data-kt-user-table-toolbar="base">
        <button type="button" class="btn btn-primary btn-sm me-3" (click)="applyFilters()">
          <i class="ki-duotone ki-magnifier fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Search with Filters
        </button>
        <button type="button" class="btn btn-light btn-sm me-3" (click)="clearFilters()">
          <i class="ki-duotone ki-cross fs-2">
            <span class="path1"></span>
          </i>
          Reset
        </button>
        <button type="button" class="btn btn-secondary btn-sm" (click)="toggleFilters()">
          <i class="ki-duotone ki-filter fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          {{ showFiltersForm ? 'Hide' : 'Show' }} Filters
        </button>
      </div>
    </div>
  </div>

  <!-- Filters Section -->
  <div class="card-body pt-0" *ngIf="showFiltersForm">
    <div class="row g-4">
      <!-- Day Filter -->
      <div class="col-md-3">
        <div class="filter-section">
          <h6 class="fw-semibold text-gray-800 mb-3">
            <i class="ki-duotone ki-calendar fs-3 me-2">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Day
          </h6>
          <div class="filter-options">
            <!-- All Checkbox -->
            <div class="form-check mb-3 pb-2 border-bottom">
              <input
                class="form-check-input"
                type="checkbox"
                id="date-all"
                [checked]="isAllDatesChecked()"
                (change)="onDateAllChange($any($event.target).checked)">
              <label class="form-check-label fw-bold text-gray-800" for="date-all">
                All
              </label>
            </div>
            <!-- Individual Date Checkboxes -->
            <div class="form-check mb-2" *ngFor="let dateOption of dateOptions">
              <input
                class="form-check-input"
                type="checkbox"
                [id]="'date-' + dateOption.value"
                [checked]="dateOption.checked"
                (change)="onDateFilterChange(dateOption.value, $event)">
              <label class="form-check-label fw-semibold text-gray-700" [for]="'date-' + dateOption.value">
                {{ dateOption.label }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Auction Hall Filter -->
      <div class="col-md-3">
        <div class="filter-section">
          <h6 class="fw-semibold text-gray-800 mb-3">
            <i class="ki-duotone ki-home fs-3 me-2">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Auction Hall
          </h6>
          <div class="filter-options">
            <!-- All Checkbox -->
            <div class="form-check mb-3 pb-2 border-bottom">
              <input
                class="form-check-input"
                type="checkbox"
                id="auction-all"
                [checked]="isAllAuctionsChecked()"
                (change)="onAuctionAllChange($any($event.target).checked)">
              <label class="form-check-label fw-bold text-gray-800" for="auction-all">
                All
              </label>
            </div>
            <!-- Individual Auction Checkboxes -->
            <div class="form-check mb-2" *ngFor="let auctionOption of auctionOptions">
              <input
                class="form-check-input"
                type="checkbox"
                [id]="'auction-' + auctionOption.value"
                [checked]="auctionOption.checked"
                (change)="onAuctionFilterChange(auctionOption.value, $event)">
              <label class="form-check-label fw-semibold text-gray-700" [for]="'auction-' + auctionOption.value">
                {{ auctionOption.label }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Make Filter -->
      <div class="col-md-3">
        <div class="filter-section">
          <h6 class="fw-semibold text-gray-800 mb-3">
            <i class="ki-duotone ki-car fs-3 me-2">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Make
            <span *ngIf="isLoadingMakes" class="spinner-border spinner-border-sm ms-2"></span>
          </h6>
          <div class="filter-options">
            <div *ngIf="!isLoadingMakes && makeOptions.length === 0" class="text-muted">
              No makes available
            </div>
            <!-- All Checkbox -->
            <div *ngIf="!isLoadingMakes && makeOptions.length > 0" class="form-check mb-3 pb-2 border-bottom">
              <input
                class="form-check-input"
                type="checkbox"
                id="make-all"
                [checked]="isAllMakesChecked()"
                (change)="onMakeAllChange($any($event.target).checked)">
              <label class="form-check-label fw-bold text-gray-800" for="make-all">
                All
              </label>
            </div>
            <!-- Individual Make Checkboxes -->
            <div class="form-check mb-2" *ngFor="let makeOption of makeOptions">
              <input
                class="form-check-input"
                type="checkbox"
                [id]="'make-' + makeOption.value"
                [checked]="makeOption.checked"
                (change)="onMakeFilterChange(makeOption.value, $event)">
              <label class="form-check-label fw-semibold text-gray-700" [for]="'make-' + makeOption.value">
                {{ makeOption.label }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Model Filter -->
      <div class="col-md-3">
        <div class="filter-section">
          <h6 class="fw-semibold text-gray-800 mb-3">
            <i class="ki-duotone ki-setting-2 fs-3 me-2">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Model
            <span *ngIf="isLoadingModels" class="spinner-border spinner-border-sm ms-2"></span>
          </h6>
          <div class="filter-options">
            <div *ngIf="!isLoadingModels && modelOptions.length === 0 && filters.makes.length === 0" class="text-muted">
              Select makes first
            </div>
            <div *ngIf="!isLoadingModels && modelOptions.length === 0 && filters.makes.length > 0" class="text-muted">
              No models available for selected makes
            </div>
            <!-- All Checkbox -->
            <div *ngIf="!isLoadingModels && modelOptions.length > 0" class="form-check mb-3 pb-2 border-bottom">
              <input
                class="form-check-input"
                type="checkbox"
                id="model-all"
                [checked]="isAllModelsChecked()"
                (change)="onModelAllChange($any($event.target).checked)">
              <label class="form-check-label fw-bold text-gray-800" for="model-all">
                All
              </label>
            </div>
            <!-- Individual Model Checkboxes -->
            <div class="form-check mb-2" *ngFor="let modelOption of modelOptions">
              <input
                class="form-check-input"
                type="checkbox"
                [id]="'model-' + modelOption.value"
                [checked]="modelOption.checked"
                (change)="onModelFilterChange(modelOption.value, $event)">
              <label class="form-check-label fw-semibold text-gray-700" [for]="'model-' + modelOption.value">
                {{ modelOption.label }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Vehicles Listing Table -->
  <div class="card-body pt-0">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center py-10">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <span class="ms-3 text-muted">Loading vehicles...</span>
    </div>

    <!-- No Data State -->
    <div *ngIf="!isLoading && vehicles.length === 0" class="d-flex flex-column align-items-center py-10">
      <i class="ki-duotone ki-car fs-3x text-muted mb-3">
        <span class="path1"></span>
        <span class="path2"></span>
      </i>
      <h5 class="text-muted">No vehicles found</h5>
      <p class="text-muted">Try adjusting your filters or check back later.</p>
    </div>

    <!-- Vehicles Table -->
    <div *ngIf="!isLoading && vehicles.length > 0" class="table-responsive">
      <table class="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
        <thead>
          <tr class="fw-bold text-muted">
            <th class="min-w-100px">Photo</th>
            <th class="min-w-150px">Auction Date<br>Time</th>
            <th class="min-w-120px">Lot Number<br>Auction Hall</th>
            <th class="min-w-80px">Year</th>
            <th class="min-w-120px">Make</th>
            <th class="min-w-120px">Model</th>
            <th class="min-w-100px">Transmission<br>Engine CC</th>
            <th class="min-w-80px">Color</th>
            <th class="min-w-100px">Chassis No.<br>Mileage</th>
            <th class="min-w-120px">Start Price(JPY)<br>Reserve(JPY)</th>
            <th class="min-w-80px">Auc. Grade</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let vehicle of vehicles; trackBy: trackByFn" class="border-bottom border-gray-200">
            <!-- Photo -->
            <td>
              <div class="symbol symbol-50px">
                <img
                  *ngIf="vehicle.pictures && vehicle.pictures.length > 1; else noImage"
                  [src]="vehicle.pictures[1]"
                  [alt]="vehicle.name"
                  class="symbol-label">
                <ng-template #noImage>
                  <div class="symbol-label bg-light-primary">
                    <i class="ki-duotone ki-car fs-2 text-primary">
                      <span class="path1"></span>
                      <span class="path2"></span>
                    </i>
                  </div>
                </ng-template>
              </div>
            </td>

            <!-- Auction Date/Hall -->
            <td>
              <div class="d-flex flex-column">
                <span class="text-dark fw-bold text-hover-primary fs-6">
                  {{ formatDateTime(vehicle.auction_date) || 'TBD' }}
                </span>
                <!-- <span class="text-muted fw-semibold text-muted d-block fs-7">
                  {{ vehicle.location || 'N/A' }}
                </span> -->
              </div>
            </td>

            <!-- Lot Number/Auction Hall with Action Buttons -->
            <td>
              <div class="d-flex flex-column">
                <span class="text-dark fw-bold fs-6 mb-2">
                  {{ vehicle.lot_no || 'N/A' }}
                </span>
                <span class="text-muted fw-semibold fs-7 mb-2">
                  {{ vehicle?.hall_name || 'N/A' }}
                </span>
                <div class="d-flex gap-1">
                  <button
                    type="button"
                    class="btn btn-success btn-sm px-2 py-1"
                    (click)="onSaveVehicle(vehicle)"
                    title="Save Vehicle">
                    <i class="ki-duotone ki-check fs-4">
                      <span class="path1"></span>
                      <span class="path2"></span>
                    </i>
                    Save
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary btn-sm px-2 py-1"
                    (click)="onMakeBid(vehicle)"
                    title="Make Bid">
                    <i class="ki-duotone ki-dollar fs-4">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                    </i>
                    Bid
                  </button>
                </div>
              </div>
            </td>

            <!-- Year -->
            <td>
              <span class="text-dark fw-bold fs-6">
                {{ vehicle.year || 'N/A' }}
              </span>
            </td>

            <!-- Make -->
            <td>
              <span class="text-dark fw-bold fs-6">
                {{ vehicle.company_name || 'N/A' }}
              </span>
            </td>

            <!-- Model -->
            <td>
              <span class="text-dark fw-bold fs-6">
                {{ vehicle.name || 'N/A' }}
              </span>
            </td>

            <!-- Transmission/Engine -->
            <td>
              <div class="d-flex flex-column">
                <span class="text-dark fw-bold fs-6">
                  {{ vehicle.transmission || 'N/A' }}
                </span>
                <span class="text-muted fw-semibold fs-7">
                  {{ vehicle.engine_capacity || 'N/A' }}
                </span>
              </div>
            </td>

            <!-- Color -->
            <td>
              <span class="text-dark fw-bold fs-6">
                {{ vehicle.color || 'N/A' }}
              </span>
            </td>

            <!-- Chassis/Mileage -->
            <td>
              <div class="d-flex flex-column">
                <span class="text-dark fw-bold fs-6">
                  {{ vehicle.vin_no || 'N/A' }}
                </span>
                <span class="text-muted fw-semibold fs-7">
                  {{ formatMileage(vehicle.mileage) }}
                </span>
              </div>
            </td>

            <!-- Price -->
            <td>
              <div class="d-flex flex-column">
                <span class="text-dark fw-bold fs-6">
                  {{ formatPrice(vehicle.price) }}
                </span>
                <span class="text-muted fw-semibold fs-7">
                  {{ formatPrice(vehicle.price) }}
                </span>
              </div>
            </td>

            <!-- Grade -->
            <td>
              <span class="badge badge-light-primary fs-7 fw-semibold">
                {{ vehicle.model_grade || 'N/A' }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div *ngIf="!isLoading && vehicles.length > 0" class="d-flex justify-content-between align-items-center mt-5">
      <div class="text-muted">
        Showing {{ paginationInfo.currentPage === 1 ? 1 : ((paginationInfo.currentPage - 1) * paginationInfo.perPage) + 1 }}
        to {{ Math.min(paginationInfo.currentPage * paginationInfo.perPage, paginationInfo.total) }}
        of {{ paginationInfo.total }} vehicles
      </div>
      <app-pagination
        [paginationInfo]="paginationInfo"
        [loading]="isLoading"
        (pageChange)="onPageChange($event)">
      </app-pagination>
    </div>
  </div>
</div>
